import { ConfigProvider } from "antd";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { resolveUiLanguage } from "./uiLanguages";

/**
 * Feeds Ant Design its own bundle for the current interface language, so the
 * strings the component library owns — table filter menus, pagination, "No
 * data", the date picker — switch along with ours.
 *
 * `useTranslation` is what subscribes this to `languageChanged`; without it the
 * provider would keep the language it first mounted with.
 */
export const AntdLocaleProvider = ({ children }: PropsWithChildren<{}>) => {
    const { i18n } = useTranslation();

    return <ConfigProvider locale={resolveUiLanguage(i18n.language).antd}>{children}</ConfigProvider>;
};
